import { ErrorMessage } from '@hookform/error-message';
import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupText, Label } from 'reactstrap';
import LabelText from './LableText';

const Input = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const { tooltip = false, pereFix, postFix, label = true, register, placeholder, errors, type, ...res } = props;
  const name = register.name;
  const labelText = LabelText(name);
  const placeholderText = !label || placeholder ? (placeholder ? placeholder : labelText) : placeholder ? placeholder : labelText;

  const mouseOutHandler = () => {
    if (tooltip) setTooltipShow(false);
  };
  const mouseOverHandler = () => {
    if (tooltip) setTooltipShow(true);
  };

  let updatedType;
  if (type === 'password') {
    updatedType = togglePassword ? 'text' : 'password';
  }
  if (type !== 'password') {
    updatedType = type;
  }

  return (
    <FormGroup>
      {label && <Label for={name}>{labelText}</Label>}
      <InputGroup>
        {pereFix && <InputGroupText>{pereFix}</InputGroupText>}
        <input type={updatedType} onMouseOut={mouseOutHandler} onMouseOver={mouseOverHandler} placeholder={placeholderText} {...res} {...register} />
        {postFix && <InputGroupText>{postFix}</InputGroupText>}
        {tooltip && tooltipShow && <InputGroupText className='input-tooltip arrow-bottom'>{labelText}</InputGroupText>}
        {type === 'password' && (
          <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
            <span className={togglePassword ? '' : 'show'}></span>
          </div>
        )}
      </InputGroup>
      <ErrorMessage
        errors={errors}
        name={name}
        render={() => {
          return (
            <span style={{ color: 'red' }}>
              {labelText}
              {(errors[name].type === 'minLength' || errors[name].type === 'maxLength' || errors[name].type === 'min' || errors[name].type === 'max') && ' is in Validated'}
              {errors[name].type === 'required' && ' is Required'}
              {errors[name].type === 'pattern' && ' is Invalid'}
            </span>
          );
        }}
      />
    </FormGroup>
  );
};

export default Input;
